module.exports = __webpack_public_path__ + "static/media/Sep_2025_2.a19006e3.webp";